module.exports = __webpack_public_path__ + "img/desserts.319add69.svg";